module.exports = __webpack_public_path__ + "static/media/flooring.713f4b12.svg";